var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupWap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 137,
    viewBox: "0 0 147 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0.043,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21785",
    "data-name": "Rectangle 21785",
    width: 147,
    height: 137,
    transform: "translate(53.5 -64.12)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.27,
    y1: 0.132,
    x2: 0.429,
    y2: 0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fba324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc7d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e64ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5edfff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21779",
    x: 59.113,
    y: 62.798,
    width: 19.249,
    height: 19.249,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21780",
    x: 102.632,
    y: 101.318,
    width: 19.249,
    height: 19.249,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21781",
    x: 94.111,
    y: 13.48,
    width: 19.249,
    height: 19.249,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21782",
    x: 125.617,
    y: 71.396,
    width: 19.249,
    height: 19.249,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd66b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_257",
    x: 76,
    y: 53,
    width: 53.606,
    height: 53.606,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fba324",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5e62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0,
    y2: 1,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    transform: "translate(-53.5 64.12)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38411",
    "data-name": "Group 38411",
    transform: "translate(11.55 -128.065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 136.574,
    cy: 118.909,
    rx: 136.574,
    ry: 118.909,
    transform: "translate(43.545 64.413)",
    opacity: 0.25,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38410",
    "data-name": "Group 38410",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 283.117, 160.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38399",
    "data-name": "Group 38399",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 0, 83.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38398",
    "data-name": "Group 38398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 69.762,
    cy: 21.099,
    rx: 69.762,
    ry: 21.099,
    transform: "translate(0 50.852)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264-2",
    "data-name": "Ellipse 264",
    cx: 21.099,
    cy: 69.762,
    rx: 21.099,
    ry: 69.762,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 81.38, 0)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264-3",
    "data-name": "Ellipse 264",
    cx: 69.762,
    cy: 21.099,
    rx: 69.762,
    ry: 21.099,
    transform: "translate(35.352 7.703) rotate(45)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 28.32, 191.92)",
    filter: "url(#Rectangle_21779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21779-2",
    "data-name": "Rectangle 21779",
    width: 3.403,
    height: 3.403,
    rx: 1.702,
    transform: "translate(70.86 69.29) rotate(107)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 28.32, 191.92)",
    filter: "url(#Rectangle_21780)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21780-2",
    "data-name": "Rectangle 21780",
    width: 3.403,
    height: 3.403,
    rx: 1.702,
    transform: "translate(114.38 107.81) rotate(107)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 28.32, 191.92)",
    filter: "url(#Rectangle_21781)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21781-2",
    "data-name": "Rectangle 21781",
    width: 3.403,
    height: 3.403,
    rx: 1.702,
    transform: "translate(105.86 19.97) rotate(107)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 28.32, 191.92)",
    filter: "url(#Rectangle_21782)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21782-2",
    "data-name": "Rectangle 21782",
    width: 3.403,
    height: 3.403,
    rx: 1.702,
    transform: "translate(137.37 77.89) rotate(107)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 28.32, 191.92)",
    filter: "url(#Ellipse_257)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257-2",
    "data-name": "Ellipse 257",
    cx: 11.855,
    cy: 11.855,
    r: 11.855,
    transform: "translate(117.61 66.93) rotate(107)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38401",
    "data-name": "Group 38401",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 119.656, 132.624)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 10.5,
    cy: 11,
    rx: 10.5,
    ry: 11,
    transform: "translate(0.409 0)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38400",
    "data-name": "Group 38400",
    transform: "translate(2.716 4.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81309",
    "data-name": "Path 81309",
    d: "M7.416,14.955,0,10.753V9.023H2.225V3.584L0,2.843V0H14.955V2.843l-1.978.742V8.4l1.36.618.618,1.73Z",
    transform: "translate(0.742 0.497)",
    fill: "#fde8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-e-Colleges_Icon",
    "data-name": "-e-Colleges Icon",
    d: "M.679,0H15.635a.68.68,0,0,1,.679.68V3.4a.68.68,0,0,1-.679.68h-1.36V8.838h1.36a.68.68,0,0,1,.679.68v2.039a.679.679,0,0,1-.34.6L8.5,16.234a.68.68,0,0,1-.653,0L.367,12.155a.679.679,0,0,1-.367-.6V9.518a.68.68,0,0,1,.679-.68h1.36V4.079H.679A.679.679,0,0,1,0,3.4V.68A.68.68,0,0,1,.679,0Zm.68,11.153,6.8,3.708,6.8-3.708V10.2H1.359Zm0-8.433h13.6V1.36H1.359ZM3.4,8.838h9.517V4.079H3.4Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38403",
    "data-name": "Group 38403",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 138.978, 75.869)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0.136 0.273)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38402",
    "data-name": "Group 38402",
    transform: "translate(2.727 3.409)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21783",
    "data-name": "Rectangle 21783",
    width: 4.45,
    height: 2.966,
    transform: "translate(5.809 11.252)",
    fill: "#fddbbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21784",
    "data-name": "Rectangle 21784",
    width: 12.853,
    height: 11.124,
    transform: "translate(1.607 1.366)",
    fill: "#fddbbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-e-Exams_Icon",
    "data-name": "-e-Exams Icon",
    d: "M2.4,16A2.415,2.415,0,0,1,0,13.571V4.857A2.415,2.415,0,0,1,2.4,2.428H4.8A2.415,2.415,0,0,1,7.2,0H8.8a2.414,2.414,0,0,1,2.4,2.428h2.4A2.414,2.414,0,0,1,16,4.857v8.714A2.415,2.415,0,0,1,13.6,16ZM1.6,4.857v8.714a.8.8,0,0,0,.8.809H13.6a.8.8,0,0,0,.8-.809V4.857a.805.805,0,0,0-.8-.809H11.2v.809a.8.8,0,0,1-.8.809H5.6a.8.8,0,0,1-.8-.809V4.047H2.4A.806.806,0,0,0,1.6,4.857ZM6.4,2.428V4.047H9.6V2.428a.8.8,0,0,0-.8-.809H7.2A.8.8,0,0,0,6.4,2.428ZM4,11.952a.81.81,0,0,1,0-1.619H8.8a.81.81,0,0,1,0,1.619ZM4,8.9A.81.81,0,0,1,4,7.285h8A.81.81,0,0,1,12,8.9Z",
    transform: "translate(15.409 15.864) rotate(180)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38406",
    "data-name": "Group 38406",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 54.321, 96.112)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(-0.273 0.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38405",
    "data-name": "Group 38405",
    transform: "translate(2.875 3.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38404",
    "data-name": "Group 38404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81310",
    "data-name": "Path 81310",
    d: "M.545,0c.477.21.912.392,1.337.593a.958.958,0,0,0,.794.018A4.711,4.711,0,0,1,7.491,1.4c.061.05.117.106.2.18-.228.027-.43.046-.632.072a7.2,7.2,0,0,0-2.3.7.639.639,0,1,0,.561,1.144,6.191,6.191,0,0,1,4.538-.373c.2.058.4.138.6.215a.717.717,0,0,0,.585-.011c.688-.307,1.378-.609,2.067-.912.022-.01.047-.017.1-.038-.026.075-.042.127-.062.178-.21.521-.412,1.046-.634,1.562a.739.739,0,0,0,.131.838,4.677,4.677,0,0,1,1.118,3.173,4.777,4.777,0,0,1-1.7,3.574,5.884,5.884,0,0,1-4.8,1.437A5.7,5.7,0,0,1,3.566,11.2a4.766,4.766,0,0,1-.48-5.7.729.729,0,0,0,.146-.553.635.635,0,0,0-1.155-.236A6.07,6.07,0,0,0,1.212,6.8c-.011.051-.023.1-.043.192-.132-.152-.256-.279-.364-.418A3.67,3.67,0,0,1,.844,1.942.771.771,0,0,0,.976,1.06C.826.728.7.385.545,0M5.673,9.345a2.392,2.392,0,1,0,4.779.156.634.634,0,0,0-.881-.591.648.648,0,0,0-.4.633,1.113,1.113,0,1,1-2.2-.284,1.161,1.161,0,0,1,.693-.816A1.732,1.732,0,0,0,8.7,6.768a.629.629,0,0,0-.606-.62.618.618,0,0,0-.657.578A.665.665,0,0,1,7,7.36,2.3,2.3,0,0,0,5.673,9.345M8.1,5.381a.637.637,0,1,0-.642-.632.638.638,0,0,0,.642.632",
    transform: "translate(1.274 1.847)",
    fill: "#fcd8bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81311",
    "data-name": "Path 81311",
    d: "M0,.755V.5A.686.686,0,0,1,1.032.1c.8.376,1.617.721,2.429,1.074a.335.335,0,0,0,.222.016A5.978,5.978,0,0,1,6.54.912a5.675,5.675,0,0,1,4.077,2.53.359.359,0,0,0,.184.122q.532.159,1.071.3a.419.419,0,0,0,.251-.01c1.08-.47,2.155-.947,3.233-1.419a.889.889,0,0,1,.288-.08.632.632,0,0,1,.609.9q-.552,1.39-1.121,2.774a.281.281,0,0,0,.037.313,6.017,6.017,0,0,1,.075,6.957,6.9,6.9,0,0,1-4.536,2.892c-.3.057-.6.086-.895.127H8.858a.844.844,0,0,0-.122-.027A6.589,6.589,0,0,1,6.591,15.8,6.438,6.438,0,0,1,2.408,10.6a.409.409,0,0,0-.189-.3,5.167,5.167,0,0,1-2.074-3C.082,7.048.048,6.785,0,6.526v-.8A.261.261,0,0,0,.022,5.67a4.97,4.97,0,0,1,.9-2.43.2.2,0,0,0,.014-.158C.629,2.3.314,1.53,0,.755M1.818,1.846c.156.385.281.729.431,1.06a.77.77,0,0,1-.131.881,3.673,3.673,0,0,0-.039,4.637c.109.139.231.266.364.417.02-.089.033-.14.043-.192a6.067,6.067,0,0,1,.865-2.09A.634.634,0,0,1,4.5,6.793a.727.727,0,0,1-.146.554,4.766,4.766,0,0,0,.481,5.7,5.687,5.687,0,0,0,3.691,1.937,5.883,5.883,0,0,0,4.8-1.436,4.772,4.772,0,0,0,1.7-3.575A4.68,4.68,0,0,0,13.917,6.8a.741.741,0,0,1-.131-.837c.222-.517.424-1.041.634-1.563.02-.05.037-.1.063-.178-.055.02-.079.029-.1.039-.689.3-1.38.6-2.066.911a.72.72,0,0,1-.586.011c-.2-.077-.394-.156-.6-.215a6.188,6.188,0,0,0-4.537.374.639.639,0,1,1-.562-1.144,7.185,7.185,0,0,1,2.3-.7c.2-.025.4-.046.631-.071-.082-.074-.137-.132-.2-.18a4.708,4.708,0,0,0-4.816-.785.96.96,0,0,1-.793-.017c-.425-.2-.86-.383-1.338-.594",
    stroke: "#ff5e62",
    strokeWidth: 0.3,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81312",
    "data-name": "Path 81312",
    d: "M0,3.2A2.3,2.3,0,0,1,1.328,1.213.661.661,0,0,0,1.76.58.619.619,0,0,1,2.418,0a.628.628,0,0,1,.605.621A1.731,1.731,0,0,1,2,2.3a1.157,1.157,0,0,0-.693.816A1.113,1.113,0,1,0,3.5,3.4a.646.646,0,0,1,.4-.633.633.633,0,0,1,.881.59A2.4,2.4,0,0,1,2.826,5.7,2.424,2.424,0,0,1,0,3.2",
    transform: "translate(6.947 7.993)",
    fill: "#ff5e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81313",
    "data-name": "Path 81313",
    d: "M.642,1.275A.637.637,0,1,1,1.274.632a.639.639,0,0,1-.632.642",
    transform: "translate(8.731 5.953)",
    fill: "#ff5e62"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38409",
    "data-name": "Group 38409",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 82.203, 118.054)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 11,
    cy: 11.5,
    rx: 11,
    ry: 11.5,
    transform: "translate(0.273 -0.227)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38408",
    "data-name": "Group 38408",
    transform: "translate(3.017 4.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38407",
    "data-name": "Group 38407",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81314",
    "data-name": "Path 81314",
    d: "M14.124,11c.159,0,.317,0,.475,0a1.033,1.033,0,0,1,.4.081.688.688,0,0,1,.377.774.719.719,0,0,1-.741.564H1.488A.711.711,0,1,1,1.465,11c.161,0,.322,0,.483,0h.044l-.406-.971q-.711-1.7-1.431-3.4A1.844,1.844,0,0,1,.02,5.611,3.037,3.037,0,0,1,1.344,3.524a3,3,0,0,1,2.4-.446,3,3,0,0,1,2.315,2.34,1.621,1.621,0,0,1-.032,1.054q-.785,1.855-1.561,3.717l-.336.8H7.342V1.422H5.124A1.626,1.626,0,0,1,4.869,1.4.7.7,0,0,1,4.28.742.7.7,0,0,1,4.469.227.791.791,0,0,1,5.049,0h6.045a.907.907,0,0,1,.128.007.708.708,0,0,1,.613.7.692.692,0,0,1-.618.7,1.755,1.755,0,0,1-.234.013H8.775V10.99h3.214l-.395-.942c-.475-1.138-.951-2.278-1.436-3.413a1.864,1.864,0,0,1-.127-1.066,3.069,3.069,0,0,1,3.008-2.576h.029a3.06,3.06,0,0,1,2.871,2.025,4.372,4.372,0,0,1,.131.468l.048.2.01.5ZM11.182.283Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81315",
    "data-name": "Path 81315",
    d: "M0,0,1.709,4.082,3.419,0Z",
    transform: "translate(11.349 6.511)",
    fill: "#fcefe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81316",
    "data-name": "Path 81316",
    d: "M0,0C.57,1.36,1.132,2.7,1.709,4.082L3.418,0Z",
    transform: "translate(1.348 6.512)",
    fill: "#fcefe2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupWap);
export default __webpack_public_path__ + "static/media/signup_wap.bc9c0bea659903ca35acf0d08576fec8.svg";
export { ForwardRef as ReactComponent };